import { DefaultChessPieces, StrokedChessPieces } from './ChessPieces';
import { DefaultTokens } from './Tokens';

export const BOARD_THEMES = {
  classic: {
    className: 'board-theme-default',
    pieces: DefaultChessPieces,
    tokens: DefaultTokens,
  },
  'classic-lite': {
    className: 'board-theme-classic-lite',
    pieces: StrokedChessPieces,
    tokens: DefaultTokens,
  },
  green: {
    className: 'board-theme-green',
    pieces: StrokedChessPieces,
    tokens: DefaultTokens,
  },
  blue: {
    className: 'board-theme-blue',
    pieces: StrokedChessPieces,
    tokens: DefaultTokens,
  },
  'gray-wood': {
    className: 'board-theme-gray-wood',
    pieces: StrokedChessPieces,
    tokens: DefaultTokens,
  },
  'school-blue': {
    className: 'board-theme-school-blue',
    pieces: StrokedChessPieces,
    tokens: DefaultTokens,
  },
  'school-green': {
    className: 'board-theme-school-green',
    pieces: StrokedChessPieces,
    tokens: DefaultTokens,
  },
  'school-purple': {
    className: 'board-theme-school-purple',
    pieces: StrokedChessPieces,
    tokens: DefaultTokens,
  },
};

export type BoardThemes = keyof typeof BOARD_THEMES;
